import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sparkles, Loader2 } from 'lucide-react';
import { getBackendUrl } from '../utils/getBackendUrl';

const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const DailyHoroscope = () => {
  const [horoscope, setHoroscope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchHoroscope();
  }, []);

  const fetchHoroscope = async () => {
    try {
      const response = await axios.get(`${API}/horoscope/daily`);
      setHoroscope(response.data);
    } catch (error) {
      console.error('Failed to fetch horoscope:', error);
      setError('Unable to load your daily horoscope');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg shadow-md p-6 border border-purple-100">
        <div className="flex items-center justify-center gap-3">
          <Loader2 className="w-5 h-5 animate-spin text-purple-600" />
          <span className="text-sm text-purple-600">Loading your daily horoscope...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return null; // Don't show anything if there's an error
  }

  if (!horoscope) {
    return null;
  }

  const getTodaysDate = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', { timeZone: 'America/Toronto', weekday: 'long', 
      month: 'long', 
      day: 'numeric' });
  };

  return (
    <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 rounded-lg shadow-md p-6 border border-purple-200">
      <div className="flex items-center gap-3 mb-4">
        <div className="bg-gradient-to-br from-purple-500 to-pink-500 p-3 rounded-xl">
          <Sparkles className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900">Your Daily Horoscope</h3>
          <p className="text-sm text-purple-600">{getTodaysDate()}</p>
        </div>
      </div>
      
      <div className="bg-white/80 backdrop-blur-sm rounded-lg p-5 border border-purple-100">
        <p className="text-gray-800 text-base leading-relaxed">
          {horoscope.horoscope}
        </p>
      </div>
      
      <div className="mt-4 text-center">
        <p className="text-xs text-gray-500">
          ✨ Powered by AI • Updated Daily
        </p>
      </div>
    </div>
  );
};
